export default "__VITE_ASSET__CcFfRvb6__"